import React from "react";
import {useIsMobile, useLanguage} from "../configuration/configuration";
import {RoundedButton} from "../navigation/buttons/nav-buttons";
import {PLACEHOLDER} from "../../static";
import {getImageServerFullUrl, getImageServerMediumUrl} from "../../actions/environment";
import YoutubePlayer from "../media-players/youtube-player";
import VimeoPlayer from "../media-players/vimeo-player";
import SoundcloudPlayer from "../media-players/soundcloud-player";
import VideoPlayer from "../media-players/video-player";
import {AddIcon, DeleteIcon, fs_regular, fs_xlarge} from "../navigation/icons/nav-icons";

const TimelineMedia = ({media, index = 0,
                           showMoreMedia = 0,
                           className,
                           onClick,
                           onDelete,
                           isEditable= false,
                           ...otherProps
                       }) => {
    const Lang = useLanguage();
    const isMobile = useIsMobile();

    const handleOnDelete = event => {
        event.preventDefault();
        onDelete(media.id);
    }

    const renderDeleteIcon = () => {
        return <RoundedButton className="btn-primary timeline-gallery-icon"
                              title={Lang.button.deleteImage.text} onClick={handleOnDelete}>
            <DeleteIcon size={fs_regular} className='clr-white'/>
        </RoundedButton>
    }

    const renderMedia = () => {
        switch (media.type) {
            case 'PICTURE': {
                return <div key={media.id} className={className}
                            data-index={index}
                            onClick={onClick}>

                    <img src={PLACEHOLDER} data-src={isMobile ?
                        getImageServerMediumUrl(media.url) :
                        getImageServerFullUrl(media.url)} alt=''/>
                    {isEditable && renderDeleteIcon()}

                    {showMoreMedia > 0 &&
                        <div className='timeline-gallery-more clr-white'>
                            <div className='centered-box m-0 p-0'>
                                <AddIcon size={fs_xlarge}/>
                                <span style={{fontSize: '2.0rem'}}>{showMoreMedia}</span>
                            </div>
                        </div>}
                </div>
            }
            case 'YOUTUBE':
                return <div className='timeline-media-youtube'>
                    <YoutubePlayer key={media.id} url={media.url} media={media}/>
                    {isEditable && renderDeleteIcon(media.id)}
                </div>

            case 'VIDEO':
                return <div className='timeline-media-youtube'>
                    <VideoPlayer media={media}/>
                    {isEditable && renderDeleteIcon(media.id)}
                </div>

            case 'VIMEO':
                return <VimeoPlayer key={media.id} url={media.url}/>

            case 'SOUNDCLOUD':
                return <SoundcloudPlayer key={media.id} url={media.url}/>

            default:
                return <div>Media not supported.. ({media.url})</div>
        }
    }

    return <div className={className}  {...otherProps}>
        {renderMedia()}
    </div>

}
export default TimelineMedia;